// CustomTooltip.js
import React from "react";

export default function CustomTooltipSTI({ active, payload, label }) {
  if (active && payload && payload.length) {
    const item = payload[0]; // first item (single bar tooltip)
    const value = item.value;

    // Two-variant color logic
    const getColor = (val) => {
      if (val === 100) return "#00a084"; // Green
      return "#dd1e47"; // Red
    };

    return (
      <div
        style={{
          backgroundColor: "#fff",
          border: `2px solid ${getColor(value)}`, // 👈 dynamic border color
          borderRadius: "8px",
          padding: "10px 14px",
          fontSize: "14px",
          color: "#333",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        {/* Title */}
        <div
          style={{
            borderBottom: "1px solid #eee",
            marginBottom: "6px",
            paddingBottom: "4px",
            fontWeight: "bold",
          }}
        >
          {label}
        </div>

        {/* Dot + value */}
        <div style={{ display: "flex", alignItems: "center" }}>
          <div
            style={{
              width: 10,
              height: 10,
              backgroundColor: getColor(value), // 👈 dot matches bar
              marginRight: 8,
              borderRadius: "50%",
            }}
          />
          <span style={{ color: "#555", marginRight: 4 }}>{item.name}:</span>
          <span style={{ fontWeight: "bold", color: getColor(value) }}>
            {value}%
          </span>
        </div>
      </div>
    );
  }
  return null;
}
